/* globals Url */
import NumUnitsSupportView from './num_units_support_view';
import Mustache from '@rover/globals/Mustache';
import Rover from '@rover/globals/Rover';
import _ from '@rover/globals/underscore';

export default NumUnitsSupportView.extend({
  template: Mustache.template('new_design/common/contiguous_dates'),
  initialize(options) {
    NumUnitsSupportView.prototype.initialize.call(this, options);
    const url = new Url();

    this.datesModel = new Rover.models.DateRange({
      start_date: options.startDate || url.query.start_date,
      end_date: url.query.end_date,
    });

    this.propagateDatesChanged(this.datesModel, 'change');

    this.datePickerView = new Rover.views.ServiceDateRangePicker({
      slug: this.service.get('service_type').slug,
      model: this.datesModel,
      disableStart: options.disableStart,
    });
  },
  render() {
    const ctx = {
      serviceName: this.service.get('service_type').name.toLowerCase(),
      supportsNumUnitsPerDay: this.numUnitsView !== null,
    };

    this.$el.html(this.template.render(ctx));
    this.$('.js-dates-view').append(this.datePickerView.render().$el);

    if (this.numUnitsView) {
      this.$('.js-num-units-view').append(this.numUnitsView.render().$el);
    }

    return this;
  },
  getDatesData() {
    let { start_date: startDate, end_date: endDate } = this.datesModel.toJSON();
    const self = this;
    const numUnits = this.getNumUnits();

    if (!startDate || !endDate) return {};
    startDate = this.formatDate(startDate);
    endDate = this.formatDate(endDate);

    if (this.numUnitsView) {
      const dates = this.dateRange(startDate, endDate);

      return {
        dates: _.map(dates, date => ({
          date: self.formatDate(date),
          num_units: numUnits,
        })),
      };
    }

    return {
      start_date: startDate,
      end_date: endDate,
    };
  },
});
